module.exports = __webpack_public_path__ + "img/ch15_02_draft3.f3e03de2.png";